module.exports = __webpack_public_path__ + "static/media/rupee.91f74007.svg";